import {useState} from 'react';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';

import FormInput from '../common/FormInput';

import {getReportNames, getReportFilterSettings} from '../../helpers/reports';

const getFields = (reportName, options = {}) => ([
  {
    name: 'report_name',
    label: 'Report Name',
    type: 'select',
    options: getReportNames().map(r => ({value: r.key, label: r.name})),
    required: true,
    fullWidth: true,
    minWidth: '250px',
    grid: {
      xs: 12,
      sm: 12,
      md: 12,
    },
  },
  ...(reportName ? getReportFilterSettings(reportName, options) : []),
]);

const ReportForm = ({onSubmit}) => {
  const [formValues, setFormValues] = useState({report_name: ''});
  const fields = (getFields(formValues?.report_name) || [])
  return (
    <Grid container spacing={1}>
      {fields.map(f => 
        <Grid item key={f.name} xs={f.grid?.xs || 12} md={f.grid?.md || 12} fullWidth>
          <FormInput 
            key={f.name} 
            {...f} 
            onChange={(e, val) => setFormValues({
              ...formValues,
              [f.name]: val || e?.target?.value,
            })}
          />
        </Grid>
      )}
      <Grid item xs={12} alignItems='center'>
        <Button
          variant='contained'
          onClick={e => onSubmit(e, formValues)}
        >
          Create Report
        </Button>
      </Grid>
    </Grid>
  );
};

export default ReportForm;